import Store from '../store';

export async function login(email, password) {
  await Store.dispatch('auth/refreshToken');
  await Store.dispatch('auth/login', {email, password});
  await Store.dispatch('auth/user');
}

export async function auth() {
  await Store.dispatch('auth/refreshToken');
  await Store.dispatch('auth/user');
}

export async function logout() {
  await Store.dispatch('auth/refreshToken');
  await Store.dispatch('auth/logout', { silence: true });

  document.location.reload();
}
